import { render, staticRenderFns } from "./tabinfeed.vue?vue&type=template&id=1bab95aa&scoped=true"
import script from "./tabinfeed.vue?vue&type=script&lang=js"
export * from "./tabinfeed.vue?vue&type=script&lang=js"
import style0 from "./tabinfeed.vue?vue&type=style&index=0&id=1bab95aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab95aa",
  null
  
)

export default component.exports